import { useMount } from 'ahooks';
import { useAppDispatch } from 'app/hooks';
import { RevxSkeleton } from 'components';
import { JobConfigFileItem } from 'domains/jobconfigDomain';
import { MultiTypeEnum, SKU } from 'domains/skuDomain';
import { JobItem } from 'domains/workspaceDomain';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import skuService from 'services/skuService';
import { RFQUploadFile } from './RFQUploadFile';
import { useUser } from 'hooks';
import '../detail/components/customer/Files/BuyerFiles.less';

export const RFQUploadFileWrapper = (
  props: JobItem & { isSupplier?: boolean }
) => {
  const isSupplier = props?.isSupplier;
  const jobData = props;
  const user = useUser();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [sku, setSku] = useState<SKU>();
  const [artFiles, setArtFiles] = useState<JobConfigFileItem[]>([]);
  useMount(async () => {
    setLoading(true);
    try {
      if (jobData?.id && jobData?.skuId) {
        const res = await dispatch.jobEstimator.getRfqFilesList(jobData?.id);
        setArtFiles(res);
        const skuDetail = await skuService.startViewSku(
          {
            id: jobData?.skuId,
          },
          true
        );
        setSku(skuDetail);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  });

  const rfqJobCanUpload = jobData?.customerId === user?.userId;

  const isWrapperSku = useMemo(() => {
    return sku?.multiType === MultiTypeEnum.WRAPPER;
  }, [sku]);
  return (
    <>
      <div className="buyer-files-card">
        <RevxSkeleton loading={loading}>
          {(isSupplier || !rfqJobCanUpload) &&
          (!artFiles || !artFiles.length) ? (
            <span>{t('workspace.detail.supplierFiles.awaitFiles')}</span>
          ) : (
            <>
              <header>
                <p>{t('workspace.detail.files.attachFiles')}</p>
              </header>
              {jobData &&
                (isWrapperSku ? (
                  <div>
                    {sku?.parts.map((partSku) => {
                      return (
                        <div className="add-files-section">
                          <div className="add-files-item-title">
                            {partSku.part.name}
                          </div>
                          <div style={{ paddingLeft: 20 }}>
                            <RFQUploadFile
                              artFiles={artFiles}
                              id={jobData?.id || 0}
                              sku={partSku.part}
                              isSupplier={isSupplier}
                              jobData={jobData}
                            />
                          </div>
                        </div>
                      );
                    })}
                    <div className="add-files-section">
                      <div className="add-files-item-title">Other Files</div>
                      <div style={{ paddingLeft: 20 }}>
                        <RFQUploadFile
                          artFiles={artFiles}
                          id={jobData?.id || 0}
                          sku={sku}
                          isSupplier={isSupplier}
                          jobData={jobData}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="add-files-section">
                    <RFQUploadFile
                      artFiles={artFiles}
                      id={jobData?.id || 0}
                      sku={sku}
                      isSupplier={isSupplier}
                      jobData={jobData}
                    />
                  </div>
                ))}
            </>
          )}
        </RevxSkeleton>
      </div>
    </>
  );
};
